/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./package-previewer.vue?vue&type=template&id=18b7267d&scoped=true&"
import script from "./package-previewer.vue?vue&type=script&lang=js&"
export * from "./package-previewer.vue?vue&type=script&lang=js&"
import style0 from "./package-previewer.vue?vue&type=style&index=0&id=18b7267d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7267d",
  null
  
)

export default component.exports